/* jshint esversion: 6 */
/* jshint ignore:start */
import './App.css';
import './css/Style.css';
import './css/Responsive.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Header from './component/Header';
import Dashboard from './component/Dashboard';
import Footer from './component/Footer';
import PaymentResponse from './Payment/PaymentResponse';
import CategoryDetails from './component/Lab/CategoryDetails';
import Shop from './component/Shop/Shop';
import LabDetails from './component/Lab/LabDetails';
import PackagesDetails from './component/Lab/PackagesDetails';
import CartBooking from './component/Lab/CartBooking';
import ShopList from './component/Shop/ShopList';
import StoreHomePage from './component/Shop/StoreHomePage';
import OurServices from './component/DocAppointment/OurServices';
import DocProfile from './component/DocAppointment/DocProfile';
import DocDetails from "./component/DocAppointment/DocDetail";
import Bookappoinment from './component/DocAppointment/Bookappointment';
import Checkout from './component/Shop/Checkout';
import Dashboard2 from './component/Profile/Dashboard';
import MyBooking from './component/Profile/MyBooking';
import MyOrder from './component/Profile/MyOrder';
import BookingDetails from './component/Profile/BookingDetails';
import OrderDetails from './component/Profile/OrderDetails';
import BookingPackage from './component/Profile/BookingPackage';
import PackageDetails from './component/Profile/PackageDetails';
import Wallet from './component/Profile/Wallet';
import Pages from './component/Profile/Pages';
import Chat from './component/Profile/Chat';
import ReferAndEarn from './component/Profile/ReferAndEarn';
import VideoCall from './component/Call/VideoCall';
import { Link, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useContext, useEffect, useState } from 'react';
import { MyContext } from './Context/MyProvider';
import { socket } from './socket';
import Faq from './component/Profile/Faq';
import HomeCareHome from './component/HomeCare/HomeCareHome';
import HomeCareDetail from './component/HomeCare/HomeCareDetail';
import HomeCareBookings from './component/HomeCare/HomeCareBookings';
import PayAppHome from './component/PayApp/PayAppHome';
import PayAppPartner from './component/PayApp/PayAppPartner';
import PayAppTxn from './component/PayApp/PayAppTxn';
import PayAppHistory from './component/PayApp/PayAppHistory';
import HomeVisitRequest from './component/HomeVisit/HomeVisitRequest';
import HomeVisitBookings from './component/HomeVisit/HomeVisitBookings';
import DoctorMap from './component/Map/DoctorMap';
import MedicineReminderList from './component/MedicineReminder/MedicineReminderList';
import AddMedicineReminder from './component/MedicineReminder/AddMedicineReminder';
import DigitalCard from './component/DigitalCard/DigitalCard';
import Notifications from './component/Notifications/Notifications';
import SubscriptionPlans from './component/Subscription/SubscriptionPlans';
import EquipmentRental from './component/Equipment/EquipmentRental';
import HealthRecords from './component/HealthRecords/HealthRecords';
import Corporate from './component/Corporate/Corporate';
import PublicFaq from './component/Faq/PublicFaq';
import PharmacySearch from './component/Pharmacy/PharmacySearch';
import PharmacyLayout from './component/Pharmacy/PharmacyLayout';
import PharmacySlots from './component/Pharmacy/PharmacySlots';
import PharmacyCheckout from './component/Pharmacy/PharmacyCheckout';
import PharmacyTrack from './component/Pharmacy/PharmacyTrack';
import LabTestsLayout from './component/Lab/LabTestsLayout';
import LabTestsBrowse from './component/Lab/LabTestsBrowse';
import LabTestsSlots from './component/Lab/LabTestsSlots';
import LabTestsCheckout from './component/Lab/LabTestsCheckout';
import LabTestsTrack from './component/Lab/LabTestsTrack';
import secureLocalStorage from "react-secure-storage";

function HomeVisitBookPage() {
  const navigate = useNavigate();
  return (
    <>
      <HomeVisitBookings />
      <HomeVisitRequest onClose={() => navigate("/home-visit/bookings")} />
    </>
  );
}

function App() {

  const { showCall, setShowCall, isLogin } = useContext(MyContext);

  const [callData, setCallData] = useState();
  const location = useLocation();

  useEffect(() => {

    const Userid = secureLocalStorage.getItem("Userid");

    if (!Userid) return;

    const handleNewChat = (msg) => {
      if (msg) {
        setShowCall(true);
        setCallData(msg);
      }
      // HandleCheckDevices(msg);
    };

    socket.on(`Other_Audio_Video_Call${Userid}`, handleNewChat);

    return () => {
      socket.off(`Other_Audio_Video_Call${Userid}`, handleNewChat);
    };

  }, [isLogin, setShowCall]);

  const HandleCheckDevices = async (msg) => {
    try {
      const deviceList = await navigator.mediaDevices.enumerateDevices();

      let hasCamera = false;
      let hasMicrophone = false;

      deviceList.forEach(device => {
        if (device.kind === 'videoinput') {
          hasCamera = true;
        }
        if (device.kind === 'audioinput') {
          hasMicrophone = true;
        }
      });

      if (hasCamera && hasMicrophone) {
        if (msg) {
          setShowCall(true);
          setCallData(msg);
        }
      }

    } catch (error) {
      console.error('Error checking devices:', error);
    }
  }

  const hideFooter = location.pathname.startsWith("/dashbord") || location.pathname.includes("paymentresponse");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className='App'>

      <Header />
      <Routes>

        <Route path='/' element={<Dashboard />} />
        <Route path='/doctor-profile/:doctorId?' element={<DocProfile />} />
        <Route path='/services' element={<OurServices />} />
        <Route path='/doctor-details/:doctorId?' element={<DocDetails />} />
        <Route path='/book-appointment/:doctorId?' element={<Bookappoinment />} />
        <Route path='/paymentresponse' element={<PaymentResponse />} />
        <Route path='/pharmacy' element={<PharmacyLayout />}>
          <Route index element={<PharmacySearch />} />
          <Route path='slots' element={<PharmacySlots />} />
          <Route path='checkout' element={<PharmacyCheckout />} />
          <Route path='track/:order_reference' element={<PharmacyTrack />} />
        </Route>
        <Route path='/lab-tests' element={<LabTestsLayout />}>
          <Route index element={<LabTestsBrowse />} />
          <Route path='slots' element={<LabTestsSlots />} />
          <Route path='checkout' element={<LabTestsCheckout />} />
          <Route path='track/:booking_reference' element={<LabTestsTrack />} />
        </Route>
        <Route path='/lab-details' element={<LabDetails />} />
        <Route path='/category-details' element={<CategoryDetails />} />
        <Route path='/packages' element={<PackagesDetails />} />
        <Route path='/cart-booking' element={<CartBooking />} />
        <Route path='/shop' element={<Shop />} />
        <Route path='/shop-list' element={<ShopList />} />
        <Route path='/store-home' element={<StoreHomePage />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/bokking' element={<MyBooking />} />
        <Route path='/home-care' element={<HomeCareHome />} />
        <Route path='/home-care/book/:id' element={<HomeCareHome />} />
        <Route path='/home-care/booking/:id' element={<HomeCareDetail />} />
        <Route path='/home-care/bookings' element={<HomeCareBookings />} />
        <Route path='/home-care/paymentresponse' element={<PaymentResponse />} />
        <Route path='/pay-app' element={<PayAppHome />} />
        <Route path='/pay-app/partner/:id' element={<PayAppPartner />} />
        <Route path='/pay-app/txn/:id' element={<PayAppTxn />} />
        <Route path='/pay-app/history' element={<PayAppHistory />} />
        <Route path='/pay-app/paymentresponse' element={<PaymentResponse />} />
        <Route path='/home-visit' element={<HomeVisitBookPage />} />
        <Route path='/home-visit/bookings' element={<HomeVisitBookings />} />
        <Route path='/map' element={<DoctorMap />} />
        <Route path='/notifications' element={<Notifications />} />
        <Route path='/subscription' element={<SubscriptionPlans />} />
        <Route path='/health-records' element={<HealthRecords />} />
        <Route path='/equipment-rental' element={<EquipmentRental />} />
        <Route path='/corporate' element={<Corporate />} />
        <Route path='/faq' element={<PublicFaq />} />
        <Route path=":title" element={<Pages />} />

        {/* Nested routes */}
        <Route path="/dashbord" element={<Dashboard2 />}>
          <Route path='booking' element={<MyBooking />} />
          <Route path='order' element={<MyOrder />} />
          <Route path='appointment-details/:appointmentId?' element={<BookingDetails />} />
          <Route path='order-details/:orderId?' element={<OrderDetails />} />
          <Route path='booking-package' element={<BookingPackage />} />
          <Route path='package-details/:packageId?' element={<PackageDetails />} />
          <Route path='wallet' element={<Wallet />} />
          <Route path='faq' element={<Faq />} />
          <Route path='medicine-reminder' element={<MedicineReminderList />} />
          <Route path='medicine-reminder/add/:reminderId?' element={<AddMedicineReminder />} />
          <Route path='digital-card' element={<DigitalCard />} />
          <Route path='health-records' element={<HealthRecords />} />
          <Route path='home-care' element={<HomeCareBookings />} />
          <Route path='pay-app' element={<PayAppHistory />} />
          <Route path='notifications' element={<Notifications />} />
          <Route path=":title" element={<Pages />} />
          <Route path="chat" element={<Chat />} />
          <Route path="refer-and-earn" element={<ReferAndEarn />} />
        </Route>
        <Route path="*" element={<div className="width-container py-20 text-center"><h1 className="text-2xl font-bold mb-4">Page not found</h1><Link to="/" className="text-rm-primary underline">Go to home</Link></div>} />
      </Routes>

      {!hideFooter && <Footer />}

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {showCall && (
        <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
          <div className="audio_box">
            <VideoCall Data={callData} />
          </div>
        </div>
      )}

    </div>
  );
}

export default App;
/* jshint ignore:end */
